import React from "react";
import UserDashboardHome from "../pages/UserDashboardHome";
import DownloadTorrent from "../pages/DownloadTorrent";
import MyFiles from "../pages/MyFiles";
import MyPlan from "../pages/MyPlan";
import Billing from "../pages/Billing";
import UserProfile from "../pages/UserProfile";
import SupportTickets from "../pages/SupportTickets";

const UserContent = ({ selectedMenu }) => {
  const render = () => {
    switch (selectedMenu) {
      case "dashboard":
        return <UserDashboardHome />;
      case "download-torrent":
        return <DownloadTorrent />;
      case "my-files":
        return <MyFiles />;
      case "my-plan":
        return <MyPlan />;
      case "billing":
        return <Billing />;
      case "profile":
        return <UserProfile />;
      case "support":
        return <SupportTickets />;
      default:
        return <UserDashboardHome />;
    }
  };
  return <div>{render()}</div>;
};

export default UserContent;
